import { useRouteResponse } from "@src/app/hooks/useRouteResponse";

import HorizontalCard from "../HorizontalCard/HorizontalCard";

export default function ArticlePopularReads() {
  const route = useRouteResponse("articlePage");
  const topArticles = route.topArticles || [];

  if (!topArticles.length) return null;

  return (
    <div className="mb-4" data-testid="article-popular-reads">
      <h3 className="text-header-3 dark:text-primary-on-dark mx-3 mb-2">
        Popular This Month
      </h3>

      <div className="ml-1">
        {topArticles.map((article, index) => (
          <HorizontalCard
            key={index}
            title={article.title || ""}
            urlPath={article.urlPath || "/"}
            category={article.sectionName || "Politics"}
            className={
              index == 0
                ? "border-divider-primary border-t pt-4"
                : "border-divider-primary dark:border-divider-secondary-on-dark border-t pt-4"
            }
            section={article.section || ""}
          />
        ))}
      </div>
    </div>
  );
}
